import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Col, Grid, Row } from '@cian/ui-kit';
import * as React from 'react';

import { PageAside } from '../../../components/PageAside';
import { Section } from '../../../components/Section';
import { Wrapper } from '../../../components/Wrapper';
import { EScrollingBlocks } from '../../../constants/scrollingBlocks';
import { VIEWED_TIMEOUT } from '../../../constants/viewedBlock';
import { trackOffersHistoryView } from '../../../utils/teaser';
import { EstimationChartContainer } from '../../EstimationChartContainer';
import { InfrastructureContainerLoad } from '../../InfrastructureMapContainer';
import { MarketPriceContainer } from '../../MarketPriceContainer';
import { OfferHistoryContainer } from '../../OfferHistory/Desktop';
import { RateOurEstimationContainer } from '../../RateOurEstimationContainer';
import { useScrollingRef } from '../../Scrolling';
import { ValuationContentContainer } from '../../ValuationContentContainer';
import { ValuationFiltersContainer } from '../../ValuationFiltersContainer';
import { ViewAllReportContainer } from '../../ViewAllReportContainer';
import { selectIsAgent } from '../../../selectors/user';
import { useSelector } from 'react-redux';
import { RateSuburbanContainer } from '../../RateSuburbanContainer';
import { selectIsFromOfferCard } from '../../../selectors/page';

export const DesktopViewContainer: React.FC = () => {
  const valuationFiltersRef = useScrollingRef(EScrollingBlocks.ValuationFilters);
  const marketPriceRef = useScrollingRef(EScrollingBlocks.MarketPrice);
  const estimationChartRef = useScrollingRef(EScrollingBlocks.EstimationChart);
  const offersHistoryRef = useScrollingRef(EScrollingBlocks.OffersHistory);
  const infrastructureRef = useScrollingRef(EScrollingBlocks.Infrastructure);

  const isAgent = useSelector(selectIsAgent);
  const isFromOfferCard = useSelector(selectIsFromOfferCard);

  return (
    <>
      <ValuationFiltersContainer refWrapper={valuationFiltersRef} />
      <Wrapper>
        <ValuationContentContainer>
          <Grid>
            <Row>
              <Col xs={9}>
                <Section marginTop={60}>
                  <MarketPriceContainer refWrapper={marketPriceRef} />
                  <RateOurEstimationContainer />
                </Section>
                {isFromOfferCard && !isAgent && (
                  <Section>
                    <RateSuburbanContainer />
                  </Section>
                )}
                <Section marginTop={60}>
                  <EstimationChartContainer refWrapper={estimationChartRef} />
                </Section>
                <Section marginTop={80}>
                  <ActionAfterViewObserver callbackDelay={VIEWED_TIMEOUT} callback={trackOffersHistoryView}>
                    <OfferHistoryContainer refWrapper={offersHistoryRef} />
                  </ActionAfterViewObserver>
                </Section>
                <Section marginTop={80}>
                  <InfrastructureContainerLoad refWrapper={infrastructureRef} />
                </Section>
              </Col>
              <Col xs={3}>
                <PageAside>
                  <ViewAllReportContainer />
                </PageAside>
              </Col>
            </Row>
          </Grid>
        </ValuationContentContainer>
      </Wrapper>
    </>
  );
};

DesktopViewContainer.displayName = 'DesktopView';
